// extracted by mini-css-extract-plugin
export default {"layout":"AppTemplate_layout__ylUI3","content":"AppTemplate_content__lnjAB","title":"AppTemplate_title__Lt6Wc","light_mode_toggle":"AppTemplate_light_mode_toggle__gT885"};